module.exports = __webpack_public_path__ + "static/media/individual.348cf0b6.webp";